import React from "react";
import { Container, Row, Col } from "shards-react";
import WorkOrderChecklist from "../components/common/work-order-checklist/WorkOrderChecklist";

const WorkOrderCheckListView = props => {
  const { id } = props.match.params;

  return (
    <Container fluid className="main-content-container px-4">
      <Row>
        <Col className="p-2">
          <WorkOrderChecklist work_order_id={id} />
        </Col>
      </Row>
    </Container>
  );
};

export default WorkOrderCheckListView;
